import adminApiClient from './adminApiClient';

export const adminPlansService = {
  // Active-only — used by public pricing page
  getCmmsPlans:     ()          => adminApiClient.get('/api/subscriptions/cmms/plans'),
  createCmmsPlan:   (data)      => adminApiClient.post('/api/subscriptions/cmms/plans', data),
  updateCmmsPlan:   (id, data)  => adminApiClient.put(`/api/subscriptions/cmms/plans/${id}`, data),
  deleteCmmsPlan:   (id)        => adminApiClient.delete(`/api/subscriptions/cmms/plans/${id}`),

  // Active-only — used by public pricing page
  getChatbotPlans:     ()         => adminApiClient.get('/api/subscriptions/chatbot/plans'),
  createChatbotPlan:   (data)     => adminApiClient.post('/api/subscriptions/chatbot/plans', data),
  updateChatbotPlan:   (id, data) => adminApiClient.put(`/api/subscriptions/chatbot/plans/${id}`, data),
  deleteChatbotPlan:   (id)       => adminApiClient.delete(`/api/subscriptions/chatbot/plans/${id}`),

  // Admin-only — returns ALL plans including inactive
  getAllCmmsPlans:    ()          => adminApiClient.get('/api/subscriptions/cmms/plans/all'),
  getAllChatbotPlans: ()          => adminApiClient.get('/api/subscriptions/chatbot/plans/all'),
};

export default adminPlansService;
